import firebase from "datastore/database";
import store from "datastore/store";

import {
  setLoading,
  addStatuses,
  deleteStatuses,
  updateStatuses,
} from "actions/booking-status";

const getCollectionUrl = (uid) => `booking-status/business/${uid}`;

export async function getStatusByUid(businessUid, statusUid) {
  const doc = await firebase
    .firestore()
    .collection(getCollectionUrl(businessUid))
    .doc(statusUid)
    .get();
  return { uid: doc.id, ...doc.data() };
}

export async function update(businessUid, uid, data) {
  return firebase
    .firestore()
    .collection(getCollectionUrl(businessUid))
    .doc(uid)
    .update(data, { merge: true });
}

export async function remove(businessUid, uid) {
  return firebase
    .firestore()
    .collection(getCollectionUrl(businessUid))
    .doc(uid)
    .delete();
}

export function add(businessUid, data) {
  const doc = firebase
    .firestore()
    .collection(getCollectionUrl(businessUid))
    .doc();
  doc.set(data);
  return { uid: doc.id, ...data };
}

export const observe = (businessUid) => {
  store.dispatch(setLoading(true));
  return firebase
    .firestore()
    .collection(getCollectionUrl(businessUid))
    .onSnapshot((snapshot) => {
      store.dispatch(setLoading(false));
      const updates = {
        added: [],
        modified: [],
        removed: [],
      };
      snapshot.docChanges().forEach((change) => {
        if (change.type === "added") {
          updates.added.push({ uid: change.doc.id, ...change.doc.data() });
        }
        if (change.type === "modified") {
          updates.modified.push({ uid: change.doc.id, ...change.doc.data() });
        }
        if (change.type === "removed") {
          updates.removed.push({ uid: change.doc.id, ...change.doc.data() });
        }
      });
      if (updates.added.length > 0) store.dispatch(addStatuses(updates));
      if (updates.modified.length > 0) store.dispatch(updateStatuses(updates));
      if (updates.removed.length > 0) store.dispatch(deleteStatuses(updates));
    });
};
